/* GENERATED by scripts/gen-data.mjs — film scene "f-frontend" (from s1.js + s2.js).
 * Structure only: every string is an i18n key resolved from
 * src/i18n/locales/<lang>/. Edit the content in the artifact and re-run
 * npm run extract, do not hand-edit here. */

import type { FilmScene } from '../../types';

export const F_FRONTEND: FilmScene = {
  "w": 640,
  "h": 300,
  "items": [
    {
      "k": "box",
      "id": "sh",
      "x": 14,
      "y": 104,
      "w": 158,
      "h": 92,
      "lKey": "films:f-frontend.items.sh.l",
      "sKey": "films:f-frontend.items.sh.s"
    },
    {
      "k": "wire",
      "id": "w0",
      "from": "sh",
      "to": "rm1",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w1",
      "from": "sh",
      "to": "rm2",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w2",
      "from": "sh",
      "to": "rm3",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w3",
      "from": "sh",
      "to": "rm4",
      "dash": true
    },
    {
      "k": "box",
      "id": "rm1",
      "x": 262,
      "y": 28,
      "w": 166,
      "h": 50,
      "lKey": "films:f-frontend.items.rm1.l"
    },
    {
      "k": "box",
      "id": "rm2",
      "x": 262,
      "y": 96,
      "w": 166,
      "h": 50,
      "lKey": "films:f-frontend.items.rm2.l",
      "sKey": "films:f-frontend.items.rm2.s"
    },
    {
      "k": "box",
      "id": "rm3",
      "x": 262,
      "y": 164,
      "w": 166,
      "h": 50,
      "lKey": "films:f-frontend.items.rm3.l",
      "sKey": "films:f-frontend.items.rm3.s"
    },
    {
      "k": "box",
      "id": "rm4",
      "x": 262,
      "y": 232,
      "w": 166,
      "h": 50,
      "lKey": "films:f-frontend.items.rm4.l"
    },
    {
      "k": "chip",
      "id": "sg",
      "x": 480,
      "y": 104,
      "w": 132,
      "h": 92,
      "lKey": "films:f-frontend.items.sg.l"
    },
    {
      "k": "wire",
      "id": "w4",
      "from": "sg",
      "to": "rm3",
      "dash": true
    },
    {
      "k": "wire",
      "id": "w5",
      "from": "sg",
      "to": "rm2",
      "dash": true
    }
  ],
  "steps": [
    {
      "on": [
        "sh"
      ],
      "hot": [
        "sh"
      ],
      "capKey": "films:f-frontend.steps.0.cap"
    },
    {
      "on": [
        "sh",
        "rm1",
        "w0"
      ],
      "hot": [
        "rm1",
        "w0"
      ],
      "capKey": "films:f-frontend.steps.1.cap"
    },
    {
      "on": [
        "sh",
        "rm1",
        "w0",
        "rm2",
        "rm3",
        "w1",
        "w2"
      ],
      "hot": [
        "rm3",
        "w2"
      ],
      "capKey": "films:f-frontend.steps.2.cap"
    },
    {
      "on": [
        "sh",
        "rm1",
        "w0",
        "rm2",
        "rm3",
        "w1",
        "w2",
        "rm4",
        "w3",
        "sg",
        "w4",
        "w5"
      ],
      "hot": [
        "sg",
        "w4"
      ],
      "capKey": "films:f-frontend.steps.3.cap"
    }
  ]
};
